import { render } from "./sendDialog.vue?vue&type=template&id=94e4f202&scoped=true"
import script from "./sendDialog.vue?vue&type=script&lang=js"
export * from "./sendDialog.vue?vue&type=script&lang=js"

import "./sendDialog.vue?vue&type=style&index=0&id=94e4f202&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-94e4f202"

export default script